<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cell-click="chooseRow"
            :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
<!--        <vxe-button @click="setFile">部署流程文件</vxe-button>-->
<!--        <vxe-button @click="setModel">转为模型</vxe-button>-->
      </template>
    </x-grid>



  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'
import {loadBaseCodeData} from "@/services/baseCodeSource";
import {dataApi} from "@/services/workflow/workflowManage";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

const fac = XGrid.factory;

//列表接口
const url = api.workflow.WORK_FLOW_MANAGE;

//主键
const rowId = 'id';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("id", "流程id", 100),
  fac.makeColumn("deploymentId", "部署id", 140),
  fac.makeColumn("name", "流程名称", 100),
  fac.makeColumn("key", "模型标识", 140),
  fac.makeColumn("version", "版本", 140),
  // fac.makeColumn("resourceName", "流程xml", 140),
  // fac.makeColumn("diagramResourceName", "流程图片", 140),
  // fac.makeColumn("suspended", "状态", 140),
  fac.makeColumn("deploymentTime", "部署时间", 160),
]

let formConfig = fac.makeFormConfig(columns, [
  {field: 'key'},
  {field: 'name'},
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  delData: false,
  import: false,
  export: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  components: {
  },
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE',
  // },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,

    }
  },
  methods: {
    setFile(){

    },
    async setModel(){
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      await dataApi.setModel(rows[0][this.rowId]);
      this.refresh();
    }
  }
}
</script>

<style scoped>
</style>